import { TOption } from 'components/OWForm/OWSelect'
import { useTranslation } from 'react-i18next'
import { ISelectorProps, Selector } from 'components/OWForm/Inputs/Selector'

export enum StatusOptions {
    All = 'All',
    Active = 'Active',
    Inactive = 'Inactive',
}

export const statusOptions: TOption[] = [
    { label: 'All', value: StatusOptions.All },
    { label: 'Active', value: StatusOptions.Active },
    { label: 'Inactive', value: StatusOptions.Inactive },
]
export function StatusSelector({
    onChange,
    value,
    ...props
}: {
    value: StatusOptions
    onChange: (v: StatusOptions) => void
} & Omit<
    ISelectorProps,
    'onChangeCallback' | 'value' | 'onChange' | 'options'
>) {
    const { t } = useTranslation()

    return (
        <Selector
            {...props}
            label={t('products.products.label.status')}
            options={statusOptions}
            value={value}
            onChangeCallback={onChange}
        />
    )
}
